var $ = require('jquery');

$(function () {
    filters();
});

function filters() {
    $('#team-categories').on('change', function () {
        var selectedCategory = $(this).val();
        window.location.href = '/team/?category=' + selectedCategory;
    });
    $('.search-member').on('change', function () {
        var searchedMember = $(this).val();
        window.location.href = '/team/?member=' + searchedMember;
    });
} 